// extracted by mini-css-extract-plugin
export default {"banner":"discord_banner__UwE-n","logoRmf":"discord_logoRmf__V7wLg","animation":"discord_animation__ClJ-W","logoDiscord":"discord_logoDiscord__-oqYg","cards":"discord_cards__zEWQv"};